import Folder from 'owa-service/lib/contract/Folder';
import updateFolderCountsInStore from '../updateFolderCountsInStore';
import { getFolder } from 'owa-mail-store/lib/services/getFolder';

export default function refreshSingleFolderCount(folderId: string) {
    getFolder(folderId).then(responseMessage => {
        const folder: Folder = responseMessage.Folders[0];

        // Folder could be null if it's been deleted on the server
        if (folder) {
            updateFolderCountsInStore(
                folder.UnreadCount,
                folder.TotalCount,
                folderId,
                false /*isDeltaChange*/
            );
        }
    });
}
